import { useEffect, useRef, useState, type FormEvent } from 'react';
import { t } from '../i18n/idioma';
import type { ChatLine } from '../world/types';
import { ChatLineView } from './Journal';

interface Props {
  name: string;
  lines: readonly ChatLine[];
  notice: string | null;
  canSend: boolean;
  onSend(text: string): void;
}

export function TellPanel({ name, lines, notice, canSend, onSend }: Props) {
  const log = useRef<HTMLDivElement>(null);
  const [draft, setDraft] = useState('');

  useEffect(() => {
    const el = log.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [lines, notice]);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const text = draft.trim();
    if (!text || !canSend) return;
    onSend(text);
    setDraft('');
  };

  return (
    <>
      <div className="journal tell-log" ref={log} role="log" aria-live="polite" aria-label={t('tell.mensagemPara', { nome: name })}>
        {lines.map((line, i) => (
          <ChatLineView key={`${line.at}-${line.name}-${i}`} line={line} />
        ))}
        {notice && <p className="warn">{notice}</p>}
      </div>
      {canSend && (
        <form className="journal-say" onSubmit={submit}>
          <input
            type="text"
            maxLength={80}
            value={draft}
            onChange={e => setDraft(e.target.value)}
            placeholder={t('tell.digaAlgo')}
            aria-label={t('tell.falarCom', { nome: name })}
            autoComplete="off"
          />
        </form>
      )}
    </>
  );
}
